import baseScmService from 'services/baseScmService';

const academyProjectService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getAcademyProject: build.query({
      query: (academyProjectId) => ({
        method: 'GET',
        url: `/academy-projects/${academyProjectId}`,
      }),
      providesTags: (result, error, academyProjectId) => {
        return error ? [] : [{ type: 'AcademyProject', id: academyProjectId }];
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetAcademyProjectQuery } = academyProjectService;

export default academyProjectService;
